export default "/dist/files/rubrique_videos.775aa7a3fca69a65ec4a241813a21ed3.svg";